import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/Navbar.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
